module.exports = __webpack_public_path__ + "static/media/img-not-found-400x220.4b4fc489.png";